export enum EmailTemplates {
	UserSignUpInvite = 'user-sign-up-invite',
	InquiryNotificationAdmin = 'inquiry-notification-admin'
}